import CategoryHeader from "./components/CategoryHeader";

export default CategoryHeader;